export const DEFAULT_HOME_TREASURY = {
    showBalance: true,
    showPayments: true,
    showExpenses: true,
    showIncomes: true,
};
export const DEFAULT_GROUP_TREASURY = {
    enabled: true,
    bankStatements: true,
};
